import Global from './Global';
import Home from './Home';
import Contact from './Contact';
import TenantArea from './TenantArea';
import Legal from './Legal';

export { filterFields } from './contentful';
export { filterLatest } from './contentful';

export const global = new Global();
export const home = new Home();
export const contact = new Contact();
export const tenantArea = new TenantArea();
export const legal = new Legal();
